"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ErrorNotificationController = require("./ErrorNotificationController");
Object.keys(_ErrorNotificationController).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ErrorNotificationController[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ErrorNotificationController[key];
    }
  });
});
